import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../components/PageLayout';
import Button from '../components/Button';

const QUICK_LINKS = [
  { label: 'IFYS Story', to: '/our-story/ifys-story' },
  { label: 'Our Services', to: '/services/ifys-services' },
  { label: 'Get Support', to: '/#support' },
  { label: 'Careers', to: '/employment/ifys-recruitment' },
  { label: 'Donate', to: '/donations/donations-at-ifys' },
  { label: 'Contact IFYS', to: '/contact/contact-ifys' },
];

const NotFoundPage = () => {
  return (
    <PageLayout activeLink="">
      <section className="bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 md:py-32 text-center">
          <p className="text-sm font-semibold tracking-[0.2em] uppercase text-ifys-blue/70">
            Error 404
          </p>
          <h1 className="mt-4 text-4xl sm:text-5xl md:text-6xl font-bold text-ifys-blue tracking-tight">
            Page not found
          </h1>
          <p className="mt-6 text-base sm:text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto">
            We can&rsquo;t find the page you&rsquo;re looking for. It may have been moved, renamed,
            or no longer exists. Try one of the links below, or head back to the homepage.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Button href="/" variant="primary" size="lg">
              Return to home
            </Button>
            <Button href="/contact/contact-ifys" variant="secondary" size="lg">
              Contact us
            </Button>
          </div>

          <div className="mt-16 pt-10 border-t border-gray-200">
            <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-6">
              Or explore
            </p>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-3">
              {QUICK_LINKS.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm sm:text-base font-medium text-ifys-blue hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ifys-blue focus-visible:ring-offset-2 rounded"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default NotFoundPage;
